import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function KitchenIcon(props: IconProps) {
    return <Icon {...props} iconKey={"kitchen"}/>
}
